import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import VermutCountdown from '../components/VermutCountdown';
import TakeawayCatering from '../components/TakeawayCatering';
import { waLink } from '../lib/contact';

const WA_VERMUT = waLink('Hola Bar Cabrero! Una pregunta sobre el vermut del domingo. Gracias!');

export default function Inicio() {
  const reviews = [
    { text: 'Trato extraordinario. Canapés de una calidad muy buena, sobre todo el de gambas. El vino blanco, riquísimo.', author: 'Luis Antonio G.', stars: 4 },
    { text: 'Excelentes canapés variados y un rico blanco de solera acompañado de una variedad de gildas. Gracias por todo.', author: 'Cliente habitual', stars: 5 },
    { text: 'Bar de toda la vida con gente de toda la vida. Alegría y servicio inmejorable. Un clásico imprescindible en Torrelavega.', author: 'Eva V.', stars: 5 },
  ];

  return (
    <>
      <Seo
        title="Gildas Artesanas en Torrelavega desde 1928"
        description="Bar Cabrero — el bar más antiguo de Torrelavega (1928). 12 variedades de gilda artesana con anchoa de Santoña DOP, tortilla casera, canapés y vermut del domingo. Para llevar y caterings. C. Julián Ceballos 19, Cantabria."
        path="/"
      />

      {/* HERO */}
      <section className="hero" data-testid="hero-section">
        <div className="hero-l">
          <p className="eyebrow rv">Torrelavega · Cantabria · Desde 1928</p>
          <h1 className="D D-xl rv" style={{ marginBottom: '1rem' }}>
            Las gildas<br />que solo hacemos<br /><em>aquí.</em>
          </h1>
          <div className="hero-pillars rv">
            <div className="pillar">Hechas a mano cada mañana — nunca precocinado</div>
            <div className="pillar">Anchoas de Santoña DOP · a solo 60 km de aquí</div>
            <div className="pillar">El bar más antiguo de Torrelavega · 96 años</div>
            <div className="pillar">Tortilla casera · preparada en casa cada día</div>
          </div>
          <div className="rv" style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
            <Link to="/gildas" className="btn btn-g" data-testid="hero-cta-gildas">Nuestras Gildas →</Link>
            <Link to="/pedido" className="btn btn-a" data-testid="hero-cta-pedido">Pídelas por WhatsApp</Link>
            <Link to="/visitanos" className="btn btn-o" data-testid="hero-cta-visitanos">Cómo llegar</Link>
          </div>
        </div>
        <div className="hero-r">
          <img
            className="hero-img"
            src="/dishes/gilda.jpg"
            alt="Gilda artesana del Bar Cabrero — anchoa de Santoña, oliva manzanilla y piparra verde"
          />
          <div className="hero-veil" />
          <div className="hero-yr">1928</div>
          <div className="hero-caption">
            <p className="hero-cap-q">"Bar icónico desde 1928. Famosos por nuestras gildas y por hacerte sentir en casa."</p>
            <p className="hero-cap-a">@cabrerobar · Instagram</p>
          </div>
        </div>
      </section>

      {/* TRUST */}
      <div className="trust rv" data-testid="trust-stats">
        <div className="trust-i"><div className="trust-n">12</div><div className="trust-l">Variedades de Gilda</div><div className="trust-s">Todas hechas a mano</div></div>
        <div className="trust-i"><div className="trust-n">96</div><div className="trust-l">Años de historia</div><div className="trust-s">El bar más antiguo de Torrelavega</div></div>
        <div className="trust-i"><div className="trust-n">60km</div><div className="trust-l">De Santoña</div><div className="trust-s">Anchoas DOP del Cantábrico</div></div>
      </div>

      {/* QUIZ TEASER — corto, mobile-first */}
      <section className="sec sec-surf" data-testid="quiz-teaser">
        <div className="qwrap" style={{ textAlign: 'center' }}>
          <p className="eyebrow rv">Descubre tu gilda</p>
          <h2 className="D D-lg rv" style={{ marginBottom: '0.75rem' }}>
            ¿Cuál es <em>tu Gilda?</em>
          </h2>
          <p className="lead rv" style={{ margin: '0 auto 2rem' }}>
            12 variedades. 3 preguntas. Te decimos cuál es la tuya.
          </p>
          <div className="rv" style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/gildas#quiz" className="btn btn-g" data-testid="quiz-teaser-btn">Hacer el quiz →</Link>
            <Link to="/gildas" className="btn btn-o">Ver las 12 variedades</Link>
          </div>
        </div>
      </section>

      {/* MANIFESTO */}
      <section className="sec" data-testid="manifesto-section">
        <p className="eyebrow rv">Por qué somos distintos</p>
        <div className="split col2">
          <div className="manifesto-dark rv">
            <h2 className="D D-lg" style={{ marginBottom: '1rem' }}>
              El 90% de los bares<br />las compran <em>hechas.</em>
            </h2>
            <p className="copy" style={{ color: 'rgba(244,247,242,0.75)' }}>
              Nosotros no. Cada mañana preparamos nuestras gildas con anchoas de Santoña llegadas del Cantábrico. Olivas manzanilla. Guindillas del norte. Una a una, con las manos.
            </p>
            <p className="copy" style={{ color: 'rgba(244,247,242,0.75)', marginTop: '0.75rem' }}>
              Y lo mismo con la tortilla. La preparamos en casa, cada día, con patata de la tierra y huevo fresco.
            </p>
            <div className="mstats">
              {[['12','variedades propias'], ['Diaria','elaboración fresca'], ['DOP','anchoa Santoña']].map(([n,l]) => (
                <div className="mstat" key={n}><div className="mstat-n">{n}</div><div className="mstat-l">{l}</div></div>
              ))}
            </div>
            <div style={{ marginTop: '1.75rem' }}>
              <Link to="/gildas" className="btn btn-a">Conoce nuestras Gildas →</Link>
            </div>
          </div>
          <div className="qcard rv">
            <p>"Una taberna de las de siempre. Los dueños al frente, recomendando y guiando. Materia prima y calidad. El trato, inmejorable."</p>
            <cite>Reseña de Google · 5 estrellas</cite>
          </div>
        </div>
      </section>

      {/* PEDIDO POR WHATSAPP — HOME PROMO */}
      <section className="sec sec-ink home-pedido" data-testid="home-pedido-promo">
        <div className="hp-grid">
          <div className="rv">
            <p className="eyebrow">Pídelo por WhatsApp</p>
            <h2 className="D D-lg" style={{ color: '#fff', marginBottom: '1rem' }}>
              Configura tu bandeja<br /><em style={{ color: 'var(--amber)' }}>en un minuto.</em>
            </h2>
            <p style={{ color: 'rgba(244,247,242,0.78)', lineHeight: 1.85, fontSize: '1rem', maxWidth: '34rem', marginBottom: '1.5rem' }}>
              Elige una bandeja predefinida o arma la tuya: cuántas de cada variedad, día y hora. Te abrimos WhatsApp con el pedido escrito — solo le das a enviar.
            </p>
            <div style={{ display: 'flex', gap: '0.85rem', flexWrap: 'wrap' }}>
              <Link to="/pedido" className="btn btn-a" data-testid="home-pedido-cta">
                Configurar mi bandeja →
              </Link>
              <Link to="/gildas" className="btn btn-w">
                Ver las 12 gildas
              </Link>
            </div>
          </div>
          <div className="hp-tiles rv" aria-hidden="true">
            <img src="/dishes/thumbs/gilda-clasica.webp" alt="" loading="lazy" />
            <img src="/dishes/thumbs/gilda-pulpo.webp" alt="" loading="lazy" />
            <img src="/dishes/thumbs/gilda-iberica.webp" alt="" loading="lazy" />
            <img src="/dishes/thumbs/gilda-picante.webp" alt="" loading="lazy" />
          </div>
        </div>
      </section>

      {/* FOTO */}
      <section className="sec" data-testid="foto-grid-section">
        <p className="eyebrow rv">Solo lo esencial</p>
        <h2 className="D D-md rv" style={{ marginBottom: '2rem' }}>Gildas, tortilla y <em>buena bebida.</em></h2>
        <div className="pgrid rv">
          {[
            { src: '/dishes/gilda.jpg',    alt: 'Gilda artesana del Bar Cabrero' },
            { src: '/dishes/tortilla.jpg', alt: 'Tortilla casera del Bar Cabrero' },
            { src: '/dishes/ing-oliva.jpg',alt: 'Olivas manzanilla' },
          ].map(({ src, alt }) => (
            <div className="pgrid-i" key={src}><img src={src} alt={alt} loading="lazy" /></div>
          ))}
        </div>
        <div className="rv" style={{ textAlign: 'center', marginTop: '2rem' }}>
          <Link to="/galeria" className="btn btn-o">Ver galería completa →</Link>
        </div>
      </section>

      {/* VERMUT */}
      <section className="sec sec-verde" id="vermut" data-testid="vermut-section">
        <div className="split col2">
          <div>
            <p className="eyebrow rv">Evento semanal</p>
            <h2 className="D D-lg rv" style={{ color: '#fff', marginBottom: '1rem' }}>
              El vermut<br /><em style={{ color: 'rgba(255,255,255,0.85)' }}>del domingo.</em>
            </h2>
            <p className="rv" style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 1.8, fontSize: '1rem', maxWidth: '36rem', marginBottom: '0.5rem' }}>
              Cada domingo, de 11:30 a 16h, el Cabrero se convierte en el ritual de Torrelavega. Vermut de grifo, gildas artesanas y la mejor compañía.
            </p>
            <div className="vermut-stats rv">
              {[['Domingos','11:30 — 16:00'], ['Vermut de grifo','Solo este día'], ['Gildas artesanas','Siempre frescas']].map(([n,l]) => (
                <div className="vstat" key={n}><div className="vstat-n">{n}</div><div className="vstat-l">{l}</div></div>
              ))}
            </div>
            <a className="btn btn-w rv" href={WA_VERMUT} target="_blank" rel="noopener noreferrer" data-testid="vermut-whatsapp">Saludar por WhatsApp</a>
          </div>
          <div className="vermut-img rv">
            <img src="/dishes/bar-vermut.jpg" alt="Vermut del domingo en Bar Cabrero Torrelavega" loading="lazy" />
          </div>
        </div>
        <div className="rv" style={{ maxWidth: '1100px', margin: '3rem auto 0' }}>
          <VermutCountdown />
        </div>
      </section>

      {/* TAKEAWAY / CATERING BANNER */}
      <TakeawayCatering variant="banner" />

      {/* HISTORIA — feature cards */}
      <section className="sec sec-surf" data-testid="feature-cards">
        <div className="split col2">
          <div>
            <p className="eyebrow rv">Nuestra historia</p>
            <h2 className="D D-lg rv" style={{ marginBottom: '1rem' }}>Casi un siglo<br /><em>en pie de barra.</em></h2>
            <p className="lead rv" style={{ marginBottom: '2rem' }}>
              Desde 1928, el Bar Cabrero ha sido el corazón del aperitivo en Torrelavega. Generaciones de familias, cuadrillas de amigos, torneos de mus.
            </p>
            <Link to="/historia" className="btn btn-g rv">Conocer la historia →</Link>
          </div>
          <div className="rv">
            <div className="fcard"><h4>La barra más alta de Torrelavega</h4><p>Varios palmos por encima de lo habitual. Un detalle que nadie olvida y que define el carácter del Cabrero.</p></div>
            <div className="fcard"><h4>Lugar de encuentro de generaciones</h4><p>Los jóvenes están obsesionados con las gildas. Los mayores llevan décadas en esta barra. El punto de encuentro de Torrelavega.</p></div>
          </div>
        </div>
      </section>

      {/* TESTIMONIOS */}
      <section className="sec" data-testid="testimonios">
        <p className="eyebrow rv">Lo que dicen los clientes</p>
        <h2 className="D D-md rv" style={{ marginBottom: '2.5rem' }}>Reseñas <em>de Google.</em></h2>
        <div className="tgrid rv">
          {reviews.map((r, i) => (
            <article className="tcard" key={i}>
              <div className="tstars">{'★'.repeat(r.stars)}{'☆'.repeat(5 - r.stars)}</div>
              <p>"{r.text}"</p>
              <cite>— {r.author}</cite>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
